import React from 'react';

const Timeline02 = () => {
    return (
        <div className="timeline section_sm bg_image_4">
            <div className="container">
                <div className="section_header">
                    <img src="images/title_back.png" alt="" />
                    <h2 className="section_title">Hungrybuzz Timeline</h2>
                    <h6 className="section_sub_title">Learn our history see our glorious journey as a restaurant</h6>
                </div>
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <ul className="timeline_history">
                            <li className="timeline_item odd" data-aos="fade-right" data-aos-duration="1000">
                                <div className="timeline_item_inner">
                                    <span className="time">1975 - 1976</span>
                                    <h6>Idea Generation</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </li>

                            <li className="timeline_item even" data-aos="fade-left" data-aos-duration="1000">
                                <div className="timeline_item_inner">
                                    <span className="time">1977 - 1978</span>
                                    <h6>Introduction</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </li>

                            <li className="timeline_item odd" data-aos="fade-right" data-aos-duration="1000">
                                <div className="timeline_item_inner">
                                    <span className="time">1979 - 1980</span>
                                    <h6>Planning</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </li>

                            <li className="timeline_item even" data-aos="fade-left" data-aos-duration="1000">
                                <div className="timeline_item_inner">
                                    <span className="time">1981 - 1982</span>
                                    <h6>Fund Collection</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </li>

                            <li className="timeline_item odd" data-aos="fade-right" data-aos-duration="1000">
                                <div className="timeline_item_inner">
                                    <span className="time">1983 - 1984</span>
                                    <h6>Construction</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </li>

                            <li className="timeline_item even" data-aos="fade-left" data-aos-duration="1000">
                                <div className="timeline_item_inner">
                                    <span className="time">1985 - 2022</span>
                                    <h6>Starting Operation</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Timeline02;